/**
 * @description this function recieve a number and formats it to a CLP currency formatted string
 * @param {number} value - the number to be formatted
 * @returns {string} - the resulting formatted string
 */
function formatMoneyToClp(value) {
    return new Intl.NumberFormat('es-CL', {
        currency: 'CLP',
        style: 'currency'
    }).format(value);
}

module.exports = {
    formatMoneyToClp: formatMoneyToClp
};
